import ErrorBoundary from './ErrorBoundary';

export default ErrorBoundary;

//TODO POINT
// Use this component to catch errors in the components below it in the tree
// This component is used in App.tsx
// This component is used in MainPage.tsx
